module.exports = require("./sq-MK.js");